
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/meilleures-techniques-dresser-animal-compagnie",
      function () {
        return require("private-next-pages/blog/meilleures-techniques-dresser-animal-compagnie/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/meilleures-techniques-dresser-animal-compagnie"])
      });
    }
  